import { request, Logger } from '@nextgen-web-framework/core';
import logObject from '../../../../logObject';
import { getSessionReqObj } from '../../config';
import { CustomRequestOptions } from '../../../types/amshopTypes';

export interface SessionData {
  type: string;
  sessionId: string;
}
export const oidcApi = {
  async getSession(options?: CustomRequestOptions): Promise<SessionData> {
    const loggerInstance = Logger.getInstance(logObject('oidcApi.getSession'));
    try {
      const req = getSessionReqObj();
      if (options?.headers) {
        req.headers = options?.headers;
      }
      if (options?.baseURL) {
        req.url = `${options.baseURL}${req.url}`;
      }

      const response: SessionData = await request(req);
      return Promise.resolve(response);
    } catch (error) {
      loggerInstance.error('oidcApi.getSession', error);
      throw error;
    }
  },
};

export default oidcApi;
